/* eslint-disable react-refresh/only-export-components */
import React from "react";
import { BreadcrumbConfigProps } from "./InterfacesAndTypes";

const defaultBreadcrumbPath = [
  { name: "Career Discovery Journey", link: "/dashboard" },
];
export const DashboardBreadcrumb: BreadcrumbConfigProps = {
  title: "Dashboard",
  path: [...defaultBreadcrumbPath],
};

export const UserBreadcrumb: BreadcrumbConfigProps = {
  title: "User Management",
  path: [...defaultBreadcrumbPath, { name: "User Management", link: "/users" }],
};

export const RoleBreadcrumb: BreadcrumbConfigProps = {
  title: "Roles Management",
  path: [...defaultBreadcrumbPath, { name: "Roles", link: "/roles" }],
};

export const UserProfileBreadcrumb: BreadcrumbConfigProps = {
  title: "User Profile",
  path: [{ name: <h3 className="career-index-title">Profile</h3> }],
};

export const ProfileChangePasswordBreadcrumb: BreadcrumbConfigProps = {
  title: "Change Password",
  path: [...defaultBreadcrumbPath, { name: "Change Password" }],
};
export const InterestAssessmentBreadcrumb: BreadcrumbConfigProps = {
  title: "Interest Discovery",
  path: [...defaultBreadcrumbPath, { name: "Interest Discovery" }],
};
export const SkillAssessmentBreadcrumb: BreadcrumbConfigProps = {
  title: "Skill Portrait",
  path: [...defaultBreadcrumbPath, { name: "Skill Portrait" }],
};
export const LocationsBreadcrumb: BreadcrumbConfigProps = {
  title: "Locations",
  path: [...defaultBreadcrumbPath, { name: "Locations" }],
};
export const ResultBreadcrumb: BreadcrumbConfigProps = {
  title: "Career Discovery Journey",
  path: [{ name: <h3 className="career-index-title">Career Discovery Journey</h3> }],
};

export const EnergyCareersIndexBreadcrumb: BreadcrumbConfigProps = {
  title: "Energy Careers Index",
  path: [
    {
      name: <h3 className="career-index-title">Energy Careers Index</h3>,
    },
  ],
};

export const SaveCareersIndexBreadcrumb: BreadcrumbConfigProps = {
  title: "Save Careers Index",
  path: [
    {
      name: <h3 className="career-index-title">Save Careers Index</h3>,
    },
  ],
};

export const ExplorationBreadcrumb: BreadcrumbConfigProps = {
  title: "Exploration",
  path: [
    {
      name: <h3 className="career-index-title">Exploration</h3>,
    },
  ],
};

export const EnergyGlossaryBreadcrumb: BreadcrumbConfigProps = {
  title: "Energy Glossary",
  path: [
    {
      name: <h3 className="career-index-title">Energy Glossary</h3>,
    },
  ],
};

export const TrainingLocationBreadcrumb: BreadcrumbConfigProps = {
  title: "Training Locations",
  path: [
    {
      name: <h3 className="career-index-title">Training Locations</h3>,
    },
  ],
};

export const EnergyIndustriesBreadcrumb: BreadcrumbConfigProps = {
  title: "Industry Awareness Hub",
  path: [
    {
      name: <h3 className="career-index-title">Industry Awareness Hub</h3>,
    },
  ],
};

export const TrainingCredentialBreadcrumb: BreadcrumbConfigProps = {
  title: "Training and Credential",
  path: [
    {
      name: <h3 className="career-index-title">Training and Credential</h3>,
    },
  ],
};

export const AllCareerBreadcrumb: BreadcrumbConfigProps = {
  title: "All Careers",
  path: [
    ...defaultBreadcrumbPath,
    { name: <h3 className="career-index-title">All Careers</h3> },
  ],
};

export const CareerSubBreadcrumb: BreadcrumbConfigProps = {
  title: "Career Details",
  path: [...defaultBreadcrumbPath, { name: "All Careers", link: "/careers" }],
};

export const SavedJobsBreadcrumb: BreadcrumbConfigProps = {
  title: "Saved Careers",
  path: [...defaultBreadcrumbPath, { name: "Saved Careers" }],
};

export const AcronymsBreadcrumb: BreadcrumbConfigProps = {
  title: "Acronyms",
  path: [...defaultBreadcrumbPath, { name: "Acronyms" }],
};

export const ResourcesBreadcrumb: BreadcrumbConfigProps = {
  title: "Resources",
  path: [...defaultBreadcrumbPath, { name: "Resources" }],
};

const CareerDetailsPath = [{ name: "Energy career index", link: "/careers" }];

export const CareerDetailsBreadcrumb = (
  careerName: string
): BreadcrumbConfigProps => ({
  title: careerName,
  path: [...CareerDetailsPath, { name: careerName }],
});

const SaveCareerDetailsPath = [
  { name: "Save career index", link: "/saved-careers" },
];

export const SaveCareerDetailsBreadcrumb = (
  careerName: string
): BreadcrumbConfigProps => ({
  title: careerName,
  path: [...SaveCareerDetailsPath, { name: careerName }],
});
